module.exports = __webpack_public_path__ + "src/assets/img/whats-new.1b3576f0.png";